import { GridCellParams, GridColDef, GridFilterItem, GridFilterOperator } from '@mui/x-data-grid';
import React from 'react';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import { SelectedWorkunit } from 'types/entities/SelectedWorkunit';
import NameCell from '../../Cells/NameCell/NameCell';
import EditionCell from '../../Cells/EditionCell/EditionCell';
import PriceCell from '../../Cells/PriceCell/PriceCell';
import TotalCell from '../../Cells/TotalCell/TotalCell';
import ReferenceCell from '../../Cells/ReferenceCell/ReferenceCell';
import Scope from 'types/entities/Scope';
import ScopeCell from '../../Cells/ScopeCell/ScopeCell';
import OrderGridPoCell from '../../Cells/OrderGridPoCell/OrderGridPoCell';
import WorkloadCell from '../../Cells/WorkloadCell/WorkloadCell';
import LabelCell from '../../Cells/LabelCell/LabelCell';
import { Typography, Box } from '@mui/material';

type SelectedWorkunitDatagridCellParams<T> = GridCellParams<SelectedWorkunit, T, any>;

export const SelectedWorkunitDatagridfield = {
  REFERENCE: 'reference',
  NAME: 'name',
  WORKLOAD: 'charge',
  PRICE: 'price',
  SCOPE: 'scope',
  DELIVERTDATE: 'delivery Date',
  PURCHASEORDER: 'purchase order',
  LABEL: 'label',
  MONTHS: 'months',
  CONTENTS: 'contents',
  TOTAL: 'total',
};

const scopeEqualOperator: GridFilterOperator[] = [
  {
    label: 'isSame',
    value: 'isSame',
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      if (!filterItem.field || !filterItem.value || !filterItem.operator) {
        return null;
      }

      return (params: GridCellParams<any, Scope>): boolean => {
        if (params.value) {
          return params.value?.id === filterItem.value;
        }
        return true;
      };
    },
  },
];

const purchaseorderEqualOperator: GridFilterOperator[] = [];

export const selectedWorkunitDatagridColumnsParams: GridColDef[] = [
  {
    headerName: SelectedWorkunitDatagridfield.REFERENCE,
    field: SelectedWorkunitDatagridfield.REFERENCE,
    minWidth: 110,
    renderCell: (params: SelectedWorkunitDatagridCellParams<string>) => (
      <ReferenceCell reference={params.value || ''} />
    ),
  },
  {
    headerName: SelectedWorkunitDatagridfield.NAME,
    field: SelectedWorkunitDatagridfield.NAME,
    minWidth: 170,
    renderCell: (params: SelectedWorkunitDatagridCellParams<string>) => <NameCell name={params.value || ''} />,
  },
  {
    field: SelectedWorkunitDatagridfield.WORKLOAD,
    headerName: 'Workload',
    minWidth: 50,
    renderCell: (params: SelectedWorkunitDatagridCellParams<number>) => <WorkloadCell charge={params.value || 0} />,
  },
  {
    field: SelectedWorkunitDatagridfield.PRICE,
    minWidth: 50,
    renderCell: (params: SelectedWorkunitDatagridCellParams<number>) => <PriceCell price={params.value || 0} />,
  },
  {
    field: SelectedWorkunitDatagridfield.SCOPE,
    minWidth: 100,
    sortable: false,
    // filterOperators: scopeEqualOperator,
    renderCell: (params: SelectedWorkunitDatagridCellParams<SelectedWorkunit>) => <ScopeCell params={params} />,
  },
  {
    field: SelectedWorkunitDatagridfield.LABEL,
    minWidth: 200,
    resizable: true,
    renderCell: (params: SelectedWorkunitDatagridCellParams<string>) => <LabelCell label={params.value || ''} />,
  },
  {
    field: SelectedWorkunitDatagridfield.PURCHASEORDER,
    minWidth: 240,
    filterOperators: purchaseorderEqualOperator,
    renderCell: (params: SelectedWorkunitDatagridCellParams<SelectedWorkunit>) => <OrderGridPoCell params={params} />,
  },
  {
    field: SelectedWorkunitDatagridfield.MONTHS,
  },
  {
    field: SelectedWorkunitDatagridfield.CONTENTS,
  },
  {
    field: SelectedWorkunitDatagridfield.TOTAL,
    align: 'center',
    headerAlign: 'center',
    minWidth: 120,
    sortable: false,
    renderCell: (params: SelectedWorkunitDatagridCellParams<number>) => (
      <TotalCell total={params.row.months.reduce((total, currentValue) => total + currentValue.quantity, 0)} />
    ),
    renderHeader: (params) => (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center', // Center content horizontally
          width: '100%', // Take full width of header
          minHeight: '100%', // Take full height of header
          cursor: 'pointer',
        }}
      >
        <Typography variant="subtitle2" sx={{ mr: 0.5 }}>
          Total
        </Typography>
        <ArrowCircleRightIcon fontSize="small" color="primary" />
        {/* You can wrap the icon in a Tooltip if the icon itself needs a tooltip */}
      </Box>
    ),
  },
  // Removed Action icons in tables
  // {
  //   field: '',
  //   align: 'center',
  //   renderCell: (params) => <EditionCell params={params} />,
  // },
];
